import styled from 'styled-components'
import { palette } from '../../Styles/colors'
import { media } from '../../Styles/media'

const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 25vh;
  z-index: 10;
  audio {
    position: absolute;
    visibility: hidden;
  }

  ${media.tablet`
    height: 95vh;
  `}
`

const Controls = styled.div`
  display: block;
  background-color: ${palette.lightone};
  color: ${palette.base};
  padding: 1.4em 0.9em;
  border-radius: 7px 0 0 7px;
  width: calc(100% * (1/9) - 1em - 1px);
  cursor: pointer;
  position: fixed;
  right: -4px;
  opacity: 1;
  box-shadow: -2px 2px 3px rgba(0,0,0,0.3);
  transition: right .2s;
  z-index: 1;
  &:hover {
    right: 0;
  }

  svg {
    stroke-width: 1;
  }

  ${media.tablet`
    width: calc(100% * (1/17) - 1em - 1px);
    padding: 0.9em 0.5em;
    opacity: 0.7;
    box-shadow: none;
  `}

  ${media.desktop`
    width: calc(100% * (1/25) - 1em - 1px);
    padding: 0.8em 0.4em;
  `}
`

export { Container, Controls }



// WEBPACK FOOTER //
// ./src/Components/Audio/styles.js